module.exports = __webpack_public_path__ + "static/media/Big-hike.1631a505.jpg";